import React, { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import Tooltip from 'LuxKit/Tooltip'
import SolidExclamationCircleIcon from 'LuxKit/Icons/solid/SolidExclamationCircleIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { ATOL_REGIONS } from 'constants/config/region'

function AtolProtectedTooltipContainer() {
  const { currentRegionCode } = useContext(GeoContext)
  const intl = useIntl()

  if (!ATOL_REGIONS.includes(currentRegionCode)) {
    return null
  }

  const atolProtectedCaption = intl.formatMessage({
    id: 'n6xqRkj3OtEfiO6_9I0U',
    defaultMessage: 'ATOL protected',
    description: 'ATOL protection badge caption text on the offer page',
  })

  return (
    <Tooltip description={
      <FormattedMessage
        id="d9I2jMMEGfdVvUa0qpzU"
        defaultMessage="<b>This trip is ATOL protected</b> for your full peace of mind."
        description="ATOL protection tooltip explaining the trip is protected"
        values={{
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    }
    >
      <CaptionTextBlock variant="medium" endIcon={<SolidExclamationCircleIcon colour="primary" />}>
        {atolProtectedCaption}
      </CaptionTextBlock>
    </Tooltip>
  )
}

export default AtolProtectedTooltipContainer
